import { constant, isFunction } from 'underscore';
import React, { useContext, useMemo, useEffect } from 'react';
import PropTypes from 'prop-types';
import { ErrorMessages } from '@bingads-webui-react/validation';
import { FormErrorContext } from './form-error-context';
import { processErrorMessages, processErrors } from './process-errors';

export const UnmappedFormErrors = React.memo(({
  className,
  filter,
  mapper,
  formErrorProps,
}) => {
  const { unmappedErrors, errorMapper } = useContext(FormErrorContext);
  const filteredUnmappedErrors = useMemo(
    () => processErrors(unmappedErrors, filter),
    [unmappedErrors, filter]
  );
  const filteredUnmappedErrorMessages = useMemo(
    () => processErrorMessages(filteredUnmappedErrors, mapper || errorMapper),
    [filteredUnmappedErrors, mapper, errorMapper]
  );

  const { onUnmappedErrorsChange } = formErrorProps;
  useEffect(() => {
    if (isFunction(onUnmappedErrorsChange)) {
      onUnmappedErrorsChange(filteredUnmappedErrors);
    }
  }, [onUnmappedErrorsChange, filteredUnmappedErrors]);

  return (
    <div className={className}>
      <ErrorMessages messages={filteredUnmappedErrorMessages} />
    </div>
  );
});

UnmappedFormErrors.propTypes = {
  className: PropTypes.string,
  filter: PropTypes.func,
  mapper: PropTypes.func,
  formErrorProps: PropTypes.shape({
    onUnmappedErrorsChange: PropTypes.func,
  }),
};

UnmappedFormErrors.defaultProps = {
  className: 'unmapped-server-errors',
  filter: constant(true),
  mapper: undefined,
  formErrorProps: {
    onUnmappedErrorsChange: undefined,
  },
};
